




























import { defineComponent, ref } from "@vue/composition-api";
import { alarm } from "@/store";

export default defineComponent({
    components: {
        ActionDialog: () =>
            import(/* webpackChunkName: "settings" */ "./Dialogs/ActionDialog.vue"),
        ConfirmDialog: () =>
            import(/* webpackChunkName: "settings" */ "./Dialogs/ConfirmDialog.vue"),
    },
    props: {
        value: { type: Boolean, default: false }, // paired?
    },
    setup(props, { emit }) {
        const showActions = ref<boolean>(false);
        const showNotAllowed = ref<boolean>(false);

        const notAllowedOk = () => {
            showNotAllowed.value = false;
        };

        const emitClick = () => {
            // keep backward compatibility: parent already listens to @click to (re)enroll
            emit("click");
            showActions.value = false;
        };

        const emitUnpair = () => {
            emit("unpair");
            showActions.value = false;
        };

        const onClick = () => {

            if (alarm.armed) {
                showNotAllowed.value = true;
                return;
            }

            if (props.value) {
                // if already paired, offer actions
                showActions.value = true;
            } else {
                // if not paired, go straight to enroll flow
                emitClick();
            }
        };

        return {
            onClick,
            showActions,
            showNotAllowed,
            notAllowedOk,
            emitClick,
            emitUnpair
        };
    },
});
